import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const PENDING_KEY = "blinxd_pending_site";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { nav("/login", { replace: true }); return; }
    // Attach any site the user entered on the register step before the Google round-trip.
    let pending = null;
    try { pending = JSON.parse(localStorage.getItem(PENDING_KEY) || "null"); } catch { pending = null; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {
          session_id: sessionId,
          site_url: pending?.site_url,
          niche: pending?.niche,
        });
        localStorage.removeItem(PENDING_KEY);
        setUser(data);
        window.history.replaceState({}, document.title, "/dashboard");
        const dest = !data.plan_chosen
          ? "/pricing"
          : data.site?.owner_verified ? "/feed" : "/dashboard";
        nav(dest, { replace: true });
      } catch (err) {
        localStorage.removeItem(PENDING_KEY);
        // New Google users must enter a site first — send them to the site-first signup.
        if (err.response?.data?.detail === "site_required") {
          window.history.replaceState({}, document.title, "/register");
          toast.error("Add your website to finish creating your account.", { duration: 6000 });
          nav("/register", { replace: true });
          return;
        }
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => nav("/login", { replace: true }), 1800);
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="font-mono text-sm tracking-[0.2em] text-terracotta animate-pulse">
        {error || "authenticating…"}
      </div>
    </div>
  );
}
